import { useEffect } from 'react';

import { Card, Col, Row, Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { doRemoveRedirectToCompleteAccountAfterSubmit } from 'src/actions';
import { useAccountSelector } from 'src/hooks';
import { MButton, MTypography } from 'src/lib';
import { Color } from 'src/styles';

import CircleProgressBar from '../../../../lib/Miscellaneous/CircleProgressBar';

import * as Styles from './CompleteAccount.styles';

export const COMPLETE_ACCOUNT_PATH = 'completeAccount';

export const CompleteAccount = () => {
  const shouldRedirect = useSelector((state: any) => state.app.redirectToCompleteAccountAfterSubmit);

  const { account } = useAccountSelector();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onCompleteAccount = () => {
    window.gtag('event', 'complete_account');
    navigate(`/accounts/personal-information`);
  };

  const renderCardContent = () => {
    if (account?.accountId && account?.type.isEntity && !account?.isEntityAccountTypeActive) {
      return (
        <>
          <Col span={24} className={Styles.almostFinished}>
            <MTypography
              variant='h4'
              weight='bold'
              align='center'
              color={Color.Brand6}
              testId='summary-account-status-title'>
              Your Account Status is Pending
            </MTypography>
            <Row>
              <Col span={24} data-testId={'summary-account-status-description'}>
                You can start viewing Offers now, but your account status must be &quot;Active&quot; before you can
                invest.
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[8, 4]} justify='center' align='middle' className={Styles.actionButtons}>
              <Col>
                <MButton
                  onClick={() => navigate(`/accounts/${account?.id}/account-status`)}
                  type='secondary'
                  className={Styles.button}
                  testId='summary-btn-account-status'>
                  Account Status
                </MButton>
              </Col>
              <Col>
                <MButton onClick={() => navigate(`/offers`)} className={Styles.button} testId='summary-btn-view-offers'>
                  View Offers
                </MButton>
              </Col>
            </Row>
          </Col>
        </>
      );
    }

    return (
      <>
        <Col span={24}>
          <CircleProgressBar percent={56} strokeWidth={5} />
        </Col>
        <Col span={24} className={Styles.almostFinished}>
          <MTypography
            variant='h4'
            weight='bold'
            align='center'
            color={Color.Brand6}
            testId='summary-account-status-title'>
            Almost Finished ...
          </MTypography>
          <Row>
            <Col span={24} data-testId={'summary-account-status-description'}>
              You can start viewing Offers now, but in order to invest you need to complete the account set up.
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[8, 4]} justify='center' align='middle' className={Styles.actionButtons}>
            <Col>
              <MButton onClick={onCompleteAccount} className={Styles.button} testId='summary-btn-complete-account'>
                Complete Account
              </MButton>
            </Col>
            <Col>
              <MButton
                onClick={() => navigate(`/offers`)}
                type='secondary'
                className={Styles.button}
                testId='summary-btn-view-offers'>
                View Offers
              </MButton>
            </Col>
          </Row>
        </Col>
      </>
    );
  };

  useEffect(() => {
    if (shouldRedirect) {
      dispatch(doRemoveRedirectToCompleteAccountAfterSubmit());
    }
  }, []);

  return (
    <>
      <Row className={Styles.completeAccountContainer}>
        <Space size={24} direction='vertical' className={Styles.containerWrapper}>
          <Col className={Styles.alignCenter}>
            <MTypography
              variant='h2'
              weight='bold'
              align='center'
              color={Color.Brand6}
              className={Styles.welcomeLabel}
              testId='summary-welcome-title'>
              Welcome!
            </MTypography>
          </Col>
          <Col className={Styles.alignCenter}>
            <Space size={0} direction='vertical'>
              <MTypography
                variant='body1'
                weight='normal'
                align='center'
                color={Color.Gray8}
                className={Styles.welcomeDescription}
                testId='summary-description'>
                Thank you for signing up to get access to some of the most exciting IPOs and other Offerings. As a
                registered user we may contact you by email with news and updates on Offerings.
              </MTypography>
              <span hidden>
                <MTypography
                  variant='body1'
                  weight='normal'
                  align='center'
                  color={Color.Gray8}
                  className={Styles.welcomeDescription}>
                  If you wish to change this, please update your{' '}
                  <a
                    onClick={() => alert('This feature is part of next iterations')}
                    className={Styles.communicationPreferencesLink}>
                    Communication Preferences.
                  </a>
                </MTypography>
              </span>
            </Space>
          </Col>
          <Col className={Styles.accountOptions}>
            <Card className={Styles.cardContent}>
              <Row gutter={[, 40]} justify='center' align='middle'>
                {renderCardContent()}
              </Row>
            </Card>
          </Col>
        </Space>
      </Row>
    </>
  );
};
